import { useAppSelector } from "@redux/app/hooks"
import { getUserData } from "@redux/features/userData/userDataSlice"
import { ReactElement } from "react"
import { useTranslation } from "react-i18next"

export interface IReportPageHeaderProps {
	customerLogo: ReactElement
	dipaiLogo: ReactElement
	reportName: string
	dateGenerated: string
	dateFrom: string
	dateTo: string
	listOfVessels: string[]
}

export default function ReportPageHeaderDipai(props: IReportPageHeaderProps) {
	const userData = useAppSelector(getUserData)
	const { t } = useTranslation()

	return (
		<div className={`flex h-50 w-full flex-row gap-0.5`}>
			<div
				className={`border-dipai-secondary-800 relative h-full w-100 border-1 bg-white`}
			>
				{props.customerLogo}
			</div>
			<div className="bg-dipai-secondary-800 relative flex h-full w-[calc(100%-400px-4px)] justify-between overflow-hidden">
				<div className="absolute right-99.5 bottom-0 z-1 flex h-[102%] w-5 origin-bottom-left translate-y-0 rotate-[5deg] flex-row">
					<div className={`w-1`} />
					<div className={`bg-dipai-primary-501 w-2`} />
					<div className={`bg-dipai-secondary-901 w-10`} />
				</div>
				<div className={`grid h-full w-250 grid-rows-5 text-white`}>
					<p
						className={`text-title2 row-span-2 content-center border-b-1 border-white px-4 font-bold`}
					>
						{props.reportName.toUpperCase()}
					</p>
					<div className={`text-menu flex flex-row items-center gap-2 px-4`}>
						<p className={`font-bold`}>{`${t("GENERATED")}: `}</p>
						<p>{`${props.dateGenerated} ${t("BY")} ${userData.name}`}</p>
					</div>
					<div className={`text-menu row-span-1 flex flex-row items-center gap-2 px-4`}>
						{props.listOfVessels !== undefined ? (
							<>
								<p className={`font-bold`}>{`${
									props.listOfVessels.length > 1 ? t("VESSELS") : t("VESSEL")
								}: `}</p>
								<p>{`${props.listOfVessels}`.replaceAll(",", ", ")}</p>
							</>
						) : null}
					</div>
					<div className={`text-menu row-span-1 flex flex-row items-center gap-2 px-4`}>
						<>
							<p className={`font-bold`}>{`${t("REPORT RANGE")}: `}</p>
							<p>{`${props.dateFrom} - ${props.dateTo}`}</p>
						</>
					</div>
				</div>
				<div className="bg-dipai-secondary-901 relative h-full w-100">
					{props.dipaiLogo}
				</div>
			</div>
		</div>
	)
}
